

module.exports = __webpack_require__.stylable.create(
    "Coupon2996390894",
    {"classes":{"root":"Coupon2996390894__root","button":"Coupon2996390894__button","textField":"Coupon2996390894__textField"},"vars":{},"stVars":{"linksColors":"'\"color(--cart_linksColor)\"'","textColor":"'\"color(--cart_textColor)\"'","textFieldFont":"'\"font({theme: 'cart_textFontStyle', size: '16px', lineHeight: '1.6'})\"'","buttonFont":"'\"font({theme: 'cart_textFontStyle', size: '16px', lineHeight: '1.2'})\"'"},"keyframes":{}},
    "",
    9,
    "Coupon2996390894",
    null
);
